// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1M6Od","visuallyhidden":"T_OuB","hide-text":"_3gcKF","center":"_3LfVX","noprint":"uMUsx","headline":"_31gHV _11zKy _1o64I"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-headline/styles/sportsfeature.scss
 ** module id = 1006
 ** module chunks = 2
 **/